import React from 'react';
import Loading from '../../../ts/components/common/Loading';
import { ManningOnlineStore } from '../../store/ManningOnlineStore';

import "./manning-online-discussions.scss";

export interface IProps {
    store: ManningOnlineStore;
}

export interface IState {}

export class ManningOnlineDiscussions extends React.Component <IProps, IState> {
    constructor(props: IProps) {
        super(props);
    }

    public render(){
        return <div className="manning-online-discussions-root">
                    {this.props.store.discussionsComponent || <Loading />}
               </div>
    }
}
